import React from "react";
import { Box } from "@mui/material";
import styles from "./PledgeList.styles";
import Typography from "../common/new/Typography/Typography";

const STATIC_LIST = [
  "I request Bharat Soka Gakkai to confer the Gohonzon.",
  "On this occasion, I make the following pledges:",
  "I PLEDGE TO EMBRACE THE GOHONZON THROUGHOUT MY LIFE.",
  "I PLEDGE TO DEDICATE MYSELF TO FAITH, PRACTICE AND STUDY IN EXACT ACCORD WITH NICHIREN DAISHONIN'S TEACHINGS.",
  "I PLEDGE TO PRACTICE IN HARMONY WITH ALL MY FELLOW MEMBERS WITH THE CORRECT UNDERSTANDING OF THE SPIRIT OF ONENESS OF MENTOR AND DISCIPLE.",
  "I PLEDGE TO FOLLOW THE GUIDANCE OF BSG AND SGI, TO OBSERVE ITS RULES AND REGULATIONS, AND NEVER TO DAMAGE THE GOOD NAME OF THE ORGANISATION.",
];

function PledgeList() {
  return (
    <Box style={styles.container}>
      <Box
        style={{
          borderRadius: "35px",
          background: "#196AAB",
          width: "90px",
          height: "44px",
          flexShrink: "0",
          marginBottom: "-20px",
          position: "relative",
          zIndex: "1",
          marginLeft: "45px",
        }}
      >
        <Typography
          variant="title3"
          style={{
            color: "#FFF",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Noto Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "20px",
            padding: "11px 18px 13px 17px",
            margin: "0",
          }}
        >
          Pledge
        </Typography>
      </Box>
      <Box style={styles.list}>
        {STATIC_LIST.map((line) => (
          <Box style={styles.listItem}>
            <Typography
              variant="small"
              color="#5e5e5e"
              decoration="underline"
              caseing="uppercase"
              weight={600}
            >
              {line}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default PledgeList;
